import React from "react"
import styled from "styled-components"

import { Element, ElementProps } from "legacy/components/shared/base"
import Footer from "legacy/components/shared/Footer"
import GlobalStyle from "legacy/components/GlobalStyles"
import Header from "legacy/components/shared/Header"
import SEO from "legacy/components/shared/SEO"
import { useTheme } from "src/legacy/utils"

import "../../styles/typography.css"
interface OwnProps {
  canonicalUrl: string
  children?: React.ReactChild | React.ReactChild[]
  jsonLD?: string
  lang?: string
  meta?: []
  ogDescription?: string
  ogImage?: string
  ogTitle?: string
  ogType?: string
  showFooter?: boolean
  showHeader?: boolean
  title?: string
}

type LayoutProps = ElementProps & OwnProps

const Layout = styled(
  ({
    canonicalUrl,
    children,
    jsonLD,
    lang,
    meta,
    ogDescription,
    ogImage,
    ogTitle,
    ogType,
    showFooter = true,
    showHeader = true,
    title,
    ...elementProps
  }) => {
    const { sizes } = useTheme()

    return (
      <>
        <GlobalStyle />
        <Element
          minHeight={
            showFooter ? `calc(100vh - ${sizes.footerHeight})` : "100vh"
          }
          {...elementProps}
        >
          {showHeader ? <Header /> : null}
          <Element
            as="main"
            paddingTop={showHeader ? ["63px", "63px", "63px", "85"] : ""}
          >
            {children}
          </Element>
        </Element>
        {showFooter ? <Footer /> : null}
      </>
    )
  }
)<LayoutProps>``

export default Layout
